module.exports = __webpack_public_path__ + "media/images/icons/file_attachment-d0dd304e96b7ac101a351e0e0c818640.png";